exports = module.exports = require("../../../_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-info {\n  position: absolute;\n  top: 0;\n  right: 0;\n  box-sizing: border-box;\n  min-width: 0.426667rem;\n  padding: 0 0.08rem;\n  color: #fff;\n  font-weight: 500;\n  font-size: 0.32rem;\n  font-family: -apple-system-font,Helvetica Neue,Arial,sans-serif;\n  line-height: 1.2;\n  text-align: center;\n  background-color: #ee0a24;\n  border: 0.026667rem solid #fff;\n  border-radius: 0.426667rem;\n  -webkit-transform: translate(50%,-50%);\n  transform: translate(50%,-50%);\n  -webkit-transform-origin: 100%;\n  transform-origin: 100%;\n}\n\n.van-info--dot {\n  width: 0.213333rem;\n  min-width: 0;\n  height: 0.213333rem;\n  background-color: #ee0a24;\n  border-radius: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_px2rem-loader@0.1.9@px2rem-loader?{"remUnit":37.5}!./~/_vant@2.13.2@vant/lib/info/index.css
// module id = 227
// module chunks = 320 321